<template>
    <div class="d-flex flex-wrap">
        <div class="img-style d-flex" v-if="imgLoading">
            <b-spinner variant="secondary" class="m-auto"></b-spinner>
        </div>
        <template v-for="(img,index) of imgUrls">
            <div :key="index" class="img-style align-content-center position-relative">
                <b-img :src="img.url" fluid center @click="viewImg(img)"></b-img>
                <div class="del-img-btn" @click="removeFile(img.name)">
                    <i class="fa-solid fa-xmark"></i>
                </div>
            </div>
        </template>
        <div class="img-style add-btn">
            <b-form-file class="input-cover flex-fill"
                         accept="image/*"
                         v-model="fileList"
                         :multiple="multiple">
            </b-form-file>
            <div class="input-mask">
                <i class="fa-regular fa-image"></i>
            </div>
        </div>

        <re-b-modal ref="viewImg" clean centered fit-content no-max-width>
            <b-img fluid fluid-grow :src="currentImg" @click="cancelView"></b-img>
        </re-b-modal>
    </div>
</template>

<script>
import fileUpload from "@/components/common/inputs/mixin/file-upload";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "ImageUpload",
    components: {ReBModal},
    mixins: [emCommonUtilMixin, fileUpload],
    props: {
        multiple: {
            type: Boolean,
            default: true
        },
        appendMode: {
            type: Boolean,
            default: true
        },
        paramName: {
            type: String,
            default: 'files'
        },
        autoUpload: {
            type: Boolean,
            default: true
        },
        ids: String,
    },
    data() {
        return {
            imgUrls: [],
            currentImg: null,
            idMap: {},
            imgLoading: false,
        }
    },
    watch: {
        finalFileList(val) {
            let tempList = [];
            for (let item of val) {
                if (item.attachmentId) {
                    tempList.push({
                        url: this._generateDownloadUrl(item.attachmentId),
                        name: item.fileName
                    })
                } else {
                    try {
                        let s = URL.createObjectURL(item);
                        tempList.push({
                            url: s.toString(),
                            name: item.name
                        });
                        URL.revokeObjectURL(item);
                    } catch (e) {
                        console.error(e)
                    }
                    if (this.autoUpload && !(item.name in this.idMap)) {
                        this.submitUpload(true, item);
                    }
                }

            }
            this.imgUrls = tempList;
            this.emitIds();
        },
    },
    mounted() {
        this.getIdImg();
    },
    methods: {
        fileListChange() {
            console.log(this.fileList);
            if (!this.autoUpload && this.submitted) {
                this.submitted = false;
                this.allFiles = {};
            }
            for (let item of this.fileList) {
                let id = this.genNonDuplicateID(5);
                let file = new File([item], id + '_' + item.name);
                this.allFiles[file.name] = file;
            }
            this.changeFlag = new Date();
        },
        viewImg(img) {
            this.currentImg = img.url;
            this.$refs.viewImg.showModal();
        },
        cancelView() {
            this.$refs.viewImg.hide();
        },
        removeFile(name) {
            if (this.appendMode && this.allFiles[name]) {
                this.$delete(this.allFiles, name);
                this.$emit('fileRemove', name);
            }
        },
        whenSuccess(response) {
            if (response && response.data) {
                for (let item of response.data) {
                    this.idMap[item.fileName + "." + item.fileNameExt] = item.id;
                    console.log(this.idMap);
                }
            }
            this.emitIds();
        },
        emitIds() {
            let tempList = [];
            for (let name in this.idMap) {
                if (name in this.allFiles) {
                    tempList.push(this.idMap[name]);
                }
            }
            this.$emit('idsChange', tempList);
        },
        getIdImg() {
            if (this.ids) {
                this.imgLoading = true;
                this.$store.dispatch('api/get', {
                    url: process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/getAttachmentList?attachmentIds=" + this.ids
                }).then(res => {
                    if (res) {
                        for (let item of res) {
                            this.idMap[item.fileName] = item.attachmentId;
                            this.$set(this.allFiles, item.fileName, item);
                        }
                    }
                }).finally(() => this.imgLoading = false);
            }
        },
    }
}
</script>

<style scoped>
.img-style {
    width: 100px;
    height: 100px;
    margin-right: .2rem;
}

.img-style img {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.add-btn {
    position: relative;
}

.input-cover {

    appearance: none;
    opacity: 0;
}

.input-cover:hover .input-mask {
    border-color: #41b883;
}

.input-cover >>> input {
    cursor: pointer;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
}

.input-cover:hover ~ div {
    border-color: #41b883;
    color: #41b883;
}

.flex-fill {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

.input-mask {
    position: absolute;
    border-radius: 0.4em;
    pointer-events: none;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border: 2px dashed #a8a8a8;
    color: #a8a8a8;
    z-index: 2;
}

.input-mask i {
    font-size: 1.5rem;
}

.del-img-btn {
    cursor: pointer;
    background-color: rgba(11, 11, 11, 0.45);
    width: 20px;
    height: 20px;
    position: absolute;
    right: 5px;
    top: 5px;
    border-radius: 50%;
    color: #dadada;
    display: flex;
}

.del-img-btn i {
    width: 10px;
    height: 10px;
    margin: auto;
}
</style>
